import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AutoAwesomeMotionOutlinedIcon from '@mui/icons-material/AutoAwesomeMotionOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import { APIENDPOINTS } from './apiEndPoint';
import axios from 'axios';

export const ROUTES: any = {
    LOGIN: '/',
    FORGOTPASSWORD: '/forgotpassword',
    RESETPASSWORD: '/reset-password/:id',
    OTPSCREEN: '/otp',
    DASHBOARD: '/dashboard',
    MANAGEDEPARTMENT: '/manage-department',
    MANAGEDEPARTMENT_add: '/manage-department/add',
    MANAGEDEPARTMENT_Edit: '/manage-department/add/:id',
    MANAGEEMPLOYEE: '/manage-employee',
    MANAGEEMPLOYEE_add: '/manage-employee/add',
    MANAGEEMPLOYEE_Edit: '/manage-employee/add/:id',
    MANAGEISSUE: '/manage-issue',
    MANAGEISSUE_View: '/manage-issue/view',
    MANAGEISSUE_DETAILE_VIEW: '/manage-issue/view/:id',
    NOTIFICATION: '/notification',
    TRAINGING_VIDEO: '/training-video',
    //
    MANAGE_ADMIN: '/manage-admin',
    CREATE_ADMIN: '/manage-admin/add',
    PROFILE_PAGE: '/profile',
}

/**global constants */
export const GLOBAL_CONSTANTS: any = {
    TITLE: "iReport",
    MAINTITLE: "iReport",

    LANGUAGES: {
        ENGLISH: "English",
    },
    INITIAL_VALUES: {
        LEFT: "Left",
        RIGHT: "Right",
        ENTER: "Enter",
        TOAST_POSITION: "top-right",
        DATE_FORMAT: "YYYY-MM-DD",
        TRUE: true,
        FALSE: false,
        ZERO_INT: 0,
        ONE_INT: 1,
        TWO_INT: 2,
        THREE_INT: 3,
        FOUR_INT: 4,
        FIVE_INT: 5,
        SIX_INT: 6,
        FIFTY_INT: 50,
        NA: "N/A",
    },
    COLOR_CODE: {
        GRADIENT: 'linear-gradient( #B59748, #B59748)',
        PRIMARY: '#B59748'
    }
}

/**Authentication pages constants*/
export const AUTHENTICATION: any = {
    SHARED: {
        ACCESS_TOKEN: "accessToken",
        REFRESH_TOKEN: "refreshToken",
        PROFILE_PICTURE: "profilePicture",
        NAME: "name",
        EMAIL: "email",
        MOBILE: "mobile",
        ROLE: "role",
        NORMAL_ADMIN: 'normal_admin',
        SUPER_ADMIN: "super_admin",
        USER_ID: "userId",
        ACCOUNT_TYPE: "accountType",
        PROFILE_HEADER: "profile_header",
        PROFILE_SETTING: "Profile & Settings",
        PROFILE_ADD: "Add Profile",
        PROFILE_EDIT: "Edit Profile",
        REMEMBERME_EMAIL: "rememberedEmail",
        REMEMBERME_PASDWORD: "rememberedPassword",
    },

    FIELDS_ERROR_MESSAGES: {
        FIRST_NAME_REQUIRED: "Please enter your First Name",
        LAST_NAME_REQUIRED: "Please enter your Last Name",
        EMAIL_REQUIRED: "Please enter the E-Mail ID",
        INVALID_EMAIL: "Please enter a valid E-Mail ID",
        PHONE_NUMBER: "Phone Number is required",
        INVALID_PHONE_NUMBER: "Please enter a valid phone number",
        DATE_OF_BIRTH_REQUIRED: "Please select your Date of Birth",
        SPACE: "Should not allow empty spaces",
        PASSWORD_REQUIRED: "Password must be at least 8 characters long",
        PASSWORD_MISMATCH: "Passwords do not match",
    },
}

/** TOASTER_CONFIGS constants*/
export const TOASTER_CONFIGS: any = {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
};

// Regex to check for at least one capital letter and one special character
export const PASDWORDREGEX = /^(?=.*[A-Z])(?=.*[!@#$%^&*])/;

export const SiderBarArray: any = [
    {
        title: "Dashboard",
        activeImg: <DashboardIcon />,
        InactiveImg: '',
        path: ROUTES.DASHBOARD,
        accountType: 1,
        adminOnly: true,
    },
    {
        title: 'Manage Admin',
        activeImg: <AdminPanelSettingsIcon />,
        InactiveImg: '',
        path: ROUTES.MANAGE_ADMIN,
        accountType: 1,
        adminOnly: false,
    },
    {
        title: 'Manage Categories',
        activeImg: <AssignmentOutlinedIcon />,
        InactiveImg: '',
        path: ROUTES.MANAGEDEPARTMENT,
        accountType: 1,
        adminOnly: false,
    },
    {
        title: 'Manage Employee',
        activeImg: <AutoAwesomeMotionOutlinedIcon />,
        InactiveImg: '',
        path: ROUTES.MANAGEEMPLOYEE,
        accountType: 1,
        adminOnly: false,
    },
    {
        title: 'Manage Issue',
        activeImg: <AssignmentLateOutlinedIcon />,
        InactiveImg: '',
        path: ROUTES.MANAGEISSUE,
        accountType: 1,
        adminOnly: true,
    },
    {
        title: 'Training Video',
        activeImg: <VideoLibraryOutlinedIcon />,
        InactiveImg: '',
        path: ROUTES.TRAINGING_VIDEO,
        accountType: 1,
        adminOnly: true,
    },
    {
        title: 'Notification',
        activeImg: <NotificationsNoneOutlinedIcon />,
        InactiveImg: '',
        path: ROUTES.NOTIFICATION,
        accountType: 1,
        adminOnly: true,
    },

]

export const ValidationHelper = {

    isNotEmpty: (str: any) => {
        return (str && str.length !== 0);
    },
    isText: (str: any) => {
        // return (str.match(/^[a-zA-Z]+$/))      
        var letters = /^[A-Za-z]+$/;
        if (str.match(letters)) {
            return true
        } else {
            return false

        }
    },
    isTextWithSpace: (str: any) => {
        // return (str.match(/^[a-zA-Z]+$/))      
        var letters = /^[A-Za-z ]+$/;
        if (str.match(letters)) {
            return true
        } else {
            return false

        }
    },
    isTextWithHyphon: (str: any) => {
        // return (str.match(/^[a-zA-Z]+$/))      
        var letters = /^[0-9-]+$/;
        if (str.match(letters)) {
            return true
        } else {
            return false

        }
    },

    isNum: (str: any) => {
        // if(str && str != null ){
        var numbers = /^\d+$/;
        if (str.match(numbers)) {
            return true
        } else {
            return false

        }
        // }
    },
    isValidUAENum: (str: any) => {
        // if(str && str != null ){
        var numbers = /^(?:\+971|00971|0)?(?:50|51|54|52|55|56|2|3|4|6|7|9)\d{7}$/;
        if (str.match(numbers)) {
            return true
        } else {
            return false

        }
        // }
    },
    isAlphaNumeric: (str: any) => {
        var numbers = /^[a-zA-Z0-9_]*$/;
        if (str.match(numbers)) {
            return true
        } else {
            return false

        }

    },
    checKCharLimit: (str: any, min: any, max: any) => {
        var strLenght = str.length
        if (strLenght >= min && strLenght <= max) {
            return true;
        }
        else {
            return false;
        }
    },
    isEmail: (email: any) => {

        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },
    checkMinLength: (str: any, minLength: any) => {
        return str.length >= minLength;
    },
    isAlphabetic: (str: any) => {
        // return /^[a-zA-Z]+$/.test(str);
        return /^[a-zA-Z][a-zA-Z\s]*$/.test(str)
    },

    isArabic: (str: any) => {
        // Arabic characters range in Unicode
        // const arabicRange = /[\u0600-\u06FF]/;
        const arabicRange = /^[\u0621-\u064A][\u0621-\u064A\s]*$/;

        return arabicRange.test(str);

    }
}

export const S3DataGetApi = async (event: any) => {
    // Check if event.target and event.target.files are defined
    const targetFiles = event?.target?.files;
    // Check if event.dataTransfer and event.dataTransfer.files are defined
    const dataTransferFiles = event?.dataTransfer?.files;
    let file;
    if (targetFiles && targetFiles.length > 0) {
        file = targetFiles[0];
    } else if (dataTransferFiles && dataTransferFiles.length > 0) {
        file = dataTransferFiles[0];
    } else {
        console.error('No files found in event', event);
        return; // Exit the function if no file is found
    }
    const formData = new FormData();
    formData.append('file', file);
    const url = `${process.env.REACT_APP_BASE_BACKEND_API_URL}${APIENDPOINTS.S3_STATIC_UPLOAD}`;
    try {
        const response = await axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response?.data?.result?.data[0];
    } catch (error) { }
};

export const calculateTime = (value: any) => {
    const now: any = new Date();
    const time: any = new Date(value);
    const timeDifference = now - time;
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (days >= 1) {
        return days === 1 ? '1 day ago' : `${days} days ago`;
    } else if (hours >= 1) {
        return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
    } else if (minutes >= 1) {
        return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
    } else {
        return 'just now';
    }
}

export const getColorFromLetter = (letter: any) => {
    const colors: any = {
        A: '#F44336', // Red
        B: '#E91E63', // Pink
        C: '#9C27B0', // Purple
        D: '#673AB7', // Deep Purple
        E: '#3F51B5', // Indigo
        F: '#2196F3', // Blue
        G: '#03A9F4', // Light Blue
        H: '#00BCD4', // Cyan
        I: '#009688', // Teal
        J: '#4CAF50', // Green
        K: '#8BC34A', // Light Green
        L: '#CDDC39', // Lime
        M: '#FFEB3B', // Yellow
        N: '#FFC107', // Amber
        O: '#FF9800', // Orange
        P: '#FF5722', // Deep Orange
        Q: '#795548', // Brown
        R: '#9E9E9E', // Grey
        S: '#607D8B', // Blue Grey
        T: '#E0E0E0', // Grey 300
        U: '#90A4AE', // Blue Grey 300
        V: '#B0BEC5', // Blue Grey 100
        W: '#CFD8DC', // Blue Grey 50
        X: '#FFCCBC', // Deep Orange 100
        Y: '#D1C4E9', // Deep Purple 100
        Z: '#C5CAE9', // Indigo 100
    };

    // Default color if letter is not in the map
    return colors[letter.toUpperCase()] || 'grey';
};

export const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};